var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkademy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8555 51.8641H51.2153V57.8106H36.8555V51.8641Z",
    fill: "#2253D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3097 62.042C24.8474 62.042 26.0939 60.7955 26.0939 59.2578C26.0939 57.7201 24.8474 56.4735 23.3097 56.4735C21.7719 56.4735 20.5254 57.7201 20.5254 59.2578C20.5254 60.7955 21.7719 62.042 23.3097 62.042Z",
    fill: "#2253D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.583 23.7147H25.4945C24.9819 23.7147 24.5664 24.1302 24.5664 24.6428V28.4117C24.5664 28.9242 24.9819 29.3397 25.4945 29.3397H62.583C63.0956 29.3397 63.5111 28.9242 63.5111 28.4117V24.6428C63.5111 24.1302 63.0956 23.7147 62.583 23.7147Z",
    fill: "#2253D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2205 29.3417L33.3789 61.8167C33.3789 62.0023 33.4529 62.0911 33.5995 62.0911H39.7195C39.8163 62.0937 39.9065 62.0399 39.9482 61.9525L45.0674 29.3417H39.2191H39.2205Z",
    fill: "#2253D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2338 61.8147C48.2687 62.0003 48.3616 62.0891 48.5109 62.0891H54.6308C54.8138 62.0891 54.8878 62.0003 54.8528 61.8147L49.2264 29.3397H43.1172L48.2338 61.8147Z",
    fill: "#2253D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkademy);
export default __webpack_public_path__ + "static/media/workademy.619dc6238e9b941ec4f58282ba6183d5.svg";
export { ForwardRef as ReactComponent };